<template>
  <div
    v-if="campaign"
    class="p1-container paywall"
  >
    <video
      autoplay
      muted
      loop
      playsinline
      class="video-background"
    >
      <source
        src="@/assets/videos/p1/video1.mp4"
        type="video/mp4"
      >
    </video>
    <div class="overlay" />

    <div class="inner-container">
      <button
        class="close-button"
        @click="handleClose"
      >×</button>

      <div class="header">
        <h1 class="title">
          {{ campaign.campaignHeader }}
        </h1>
        <p class="subtitle">
          {{ campaign.campaignText }}
        </p>
      </div>

      <div>
        <div class="features">
          <div
            v-for="(feature, index) in features"
            :key="index"
            class="feature-item"
          >
            <component v-if="feature.icon && feature.text" :is="feature.icon" />
            <span v-if="feature.icon && feature.text">{{ feature.text }}</span>
          </div>
        </div>

        <div class="price-container">
          <div>
            <div class="price">
              {{ $t('{count} Diamonds', { count: numberFormat(diamond) }) }}
            </div>
            <div v-if="showOriginalPrice">
              <span class="original-price">
                {{ originalPrice }}{{ campaign.currency === 'USD' ? '$' : '&#8378;' }}
              </span>
              <span class="price-slogan">
                {{ $t('Limited time offer') }}
              </span>
              <span
                v-if="campaign.campaignType === 'ONE_TIME_OFFER' && campaignCounter"
                class="price-slogan"
              >
                <feather-icon
                  icon="ClockIcon"
                  size="10"
                />
                <span v-if="campaignCounter.hours != '00'">
                  {{ campaignCounter.hours }}:
                </span>
                {{ campaignCounter.minutes }}:{{ campaignCounter.seconds }}
              </span>
            </div>
            <div class="price">
              <small>
                {{ $t('Just for you') }}
              </small>
              {{ campaign.amount }}{{ campaign.currency === 'USD' ? '$' : '&#8378;' }}
            </div>
          </div>
          <span class="discount-badge">
            <span>
              {{ $t('Discount') }}
            </span>
          </span>
        </div>

        <button
          class="start-button"
          @click="handleBuy"
        >
          {{ $t('Start Having Fun') }}!
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { numberFormat } from '@/helpers/helpers'

// SVG İkonları bileşenleri

const DiamondIcon = {
  render(h) {
    return h('svg', {
      attrs: {
        width: '19',
        height: '17',
        viewBox: '0 0 19 17',
        fill: 'none',
        xmlns: 'http://www.w3.org/2000/svg',
      },
    }, [
      h('path', {
        attrs: {
          d: 'M6.73636 5.2193L9.35195 0H9.64805L12.2636 5.2193H6.73636ZM8.75974 17L0.246753 6.71053H8.75974V17ZM10.2403 17V6.71053H18.7532L10.2403 17ZM13.8922 5.2193L11.326 0H16.4091L19 5.2193H13.8922ZM0 5.2193L2.59091 0H7.67403L5.10779 5.2193H0Z',
          fill: 'white',
        },
      }),
    ])
  },
}

const ChatIcon = {
  render(h) {
    return h('svg', {
      attrs: {
        width: '18',
        height: '17',
        viewBox: '0 0 18 17',
        fill: 'none',
        xmlns: 'http://www.w3.org/2000/svg',
      },
    }, [
      h('path', {
        attrs: {
          d: 'M4.33926 0.130767C5.51302 7.79432e-08 7.02084 0 8.96065 0H9.03935C10.9792 0 12.487 7.79432e-08 13.6607 0.130767C14.8479 0.264149 15.7881 0.540504 16.5382 1.1647C17.3085 1.80633 17.6685 2.64062 17.8384 3.69286C18 4.69715 18 5.97518 18 7.56879V7.72833C18 9.28184 18 10.3567 17.8326 11.1579C17.754 11.5696 17.599 11.9614 17.3763 12.3113C17.1553 12.653 16.874 12.9407 16.5391 13.2197C15.7881 13.8447 14.8479 14.1202 13.6607 14.2527C12.487 14.3844 10.9792 14.3844 9.03935 14.3844H9C8.11591 14.3844 7.44028 14.6956 6.73367 15.1742C6.44735 15.3669 6.16856 15.5787 5.86633 15.8097L5.61181 16.0015C5.21414 16.3023 4.77963 16.6205 4.28902 16.9134C4.19352 16.9704 4.08531 17.0003 3.97523 17C3.86515 16.9997 3.75707 16.9693 3.66183 16.9118C3.5666 16.8543 3.48755 16.7718 3.43262 16.6725C3.37768 16.5731 3.34879 16.4605 3.34884 16.3459V14.0923C2.61293 13.9267 1.99005 13.6599 1.46177 13.2205C1.12688 12.9407 0.844744 12.6539 0.624558 12.3113C0.401549 11.9615 0.246272 11.5697 0.167442 11.1579C3.74262e-08 10.3567 0 9.28184 0 7.72833V7.56879C0 5.97518 -3.74262e-08 4.69715 0.161581 3.69373C0.331535 2.64062 0.691535 1.80633 1.46177 1.1647C2.21191 0.539632 3.15209 0.263278 4.33926 0.130767ZM6.27907 7.19306C6.27907 7.01965 6.21291 6.85334 6.09516 6.73073C5.9774 6.60811 5.81769 6.53922 5.65116 6.53922C5.48463 6.53922 5.32492 6.60811 5.20717 6.73073C5.08941 6.85334 5.02326 7.01965 5.02326 7.19306V7.62895C5.02326 7.80236 5.08941 7.96866 5.20717 8.09128C5.32492 8.2139 5.48463 8.28278 5.65116 8.28278C5.81769 8.28278 5.9774 8.2139 6.09516 8.09128C6.21291 7.96866 6.27907 7.80236 6.27907 7.62895V7.19306ZM9.62791 7.19306C9.62791 7.01965 9.56175 6.85334 9.444 6.73073C9.32624 6.60811 9.16653 6.53922 9 6.53922C8.83347 6.53922 8.67376 6.60811 8.556 6.73073C8.43825 6.85334 8.37209 7.01965 8.37209 7.19306V7.62895C8.37209 7.80236 8.43825 7.96866 8.556 8.09128C8.67376 8.2139 8.83347 8.28278 9 8.28278C9.16653 8.28278 9.32624 8.2139 9.444 8.09128C9.56175 7.96866 9.62791 7.80236 9.62791 7.62895V7.19306ZM12.9767 7.19306C12.9767 7.01965 12.9106 6.85334 12.7928 6.73073C12.6751 6.60811 12.5154 6.53922 12.3488 6.53922C12.1823 6.53922 12.0226 6.60811 11.9048 6.73073C11.7871 6.85334 11.7209 7.01965 11.7209 7.19306V7.62895C11.7209 7.80236 11.7871 7.96866 11.9048 8.09128C12.0226 8.2139 12.1823 8.28278 12.3488 8.28278C12.5154 8.28278 12.6751 8.2139 12.7928 8.09128C12.9106 7.96866 12.9767 7.80236 12.9767 7.62895V7.19306Z',
          fill: 'white',
        },
      }),
    ])
  },
}

const StarIcon = {
  render(h) {
    return h('svg', {
      attrs: {
        width: '20',
        height: '20',
        viewBox: '0 0 24 24',
        fill: 'none',
        xmlns: 'http://www.w3.org/2000/svg',
      },
    }, [
      h('circle', {
        attrs: {
          cx: '12',
          cy: '12',
          r: '10',
          stroke: 'white',
          'stroke-width': '2',
        },
      }),
      h('path', {
        attrs: {
          d: 'M12 6L13.09 10.26L17.18 10.27L14 12.97L15.09 17.23L12 14.53L8.91 17.23L10 12.97L6.82 10.27L10.91 10.26L12 6Z',
          fill: 'white',
        },
      }),
    ])
  },
}

const CrownIcon = {
  render(h) {
    return h('svg', {
      attrs: {
        width: '19',
        height: '17',
        viewBox: '0 0 19 17',
        fill: 'none',
        xmlns: 'http://www.w3.org/2000/svg',
      },
    }, [
      h('path', {
        attrs: {
          d: 'M2.85 17V15.1111H16.15V17H2.85ZM2.85 13.6944L1.63875 6.11528C1.60708 6.11528 1.5713 6.11937 1.5314 6.12756C1.4915 6.13574 1.45603 6.13952 1.425 6.13889C1.02917 6.13889 0.692868 6.001 0.416102 5.72522C0.139335 5.44945 0.000635492 5.11511 2.15909e-06 4.72222C-0.000631174 4.32934 0.138069 3.995 0.416102 3.71922C0.694135 3.44345 1.03043 3.30556 1.425 3.30556C1.81957 3.30556 2.15618 3.44345 2.43485 3.71922C2.71352 3.995 2.8519 4.32934 2.85 4.72222C2.85 4.83241 2.83797 4.93472 2.8139 5.02917C2.78983 5.12361 2.76228 5.21019 2.73125 5.28889L5.7 6.61111L8.66875 2.57361C8.49458 2.44769 8.35208 2.28241 8.24125 2.07778C8.13041 1.87315 8.075 1.65278 8.075 1.41667C8.075 1.02315 8.2137 0.688502 8.4911 0.412724C8.7685 0.136947 9.1048 -0.000627478 9.5 2.15135e-06C9.8952 0.000631781 10.2318 0.138521 10.5098 0.413669C10.7879 0.688817 10.9263 1.02315 10.925 1.41667C10.925 1.65278 10.8696 1.87315 10.7587 2.07778C10.6479 2.28241 10.5054 2.44769 10.3312 2.57361L13.3 6.61111L16.2687 5.28889C16.2371 5.21019 16.2092 5.12361 16.1851 5.02917C16.1611 4.93472 16.1494 4.83241 16.15 4.72222C16.15 4.32871 16.2887 3.99406 16.5661 3.71828C16.8435 3.4425 17.1798 3.30493 17.575 3.30556C17.9702 3.30619 18.3068 3.44408 18.5848 3.71922C18.8629 3.99437 19.0013 4.32871 19 4.72222C18.9987 5.11574 18.8603 5.45039 18.5848 5.72617C18.3093 6.00195 17.9727 6.13952 17.575 6.13889C17.5433 6.13889 17.5079 6.13511 17.4686 6.12756C17.4293 6.12 17.3935 6.11591 17.3612 6.11528L16.15 13.6944H2.85Z',
          fill: 'white',
        },
      }),
    ])
  },
}

const HeadphoneIcon = {
  render(h) {
    return h('svg', {
      attrs: {
        width: '20',
        height: '18',
        viewBox: '0 0 20 18',
        fill: 'none',
        xmlns: 'http://www.w3.org/2000/svg',
      },
    }, [
      h('path', {
        attrs: {
          d: 'M19 9.22C19 3.73 14.74 0 10 0C5.31 0 1 3.65 1 9.28C0.4 9.62 0 10.26 0 11V13C0 14.1 0.9 15 2 15H3V8.9C3 5.03 6.13 1.9 10 1.9C13.87 1.9 17 5.03 17 8.9V16H9V18H17C18.1 18 19 17.1 19 16V14.78C19.59 14.47 20 13.86 20 13.14V10.84C20 10.14 19.59 9.53 19 9.22Z',
          fill: 'white',
        },
      }),
      h('path', {
        attrs: {
          d: 'M7 11C7.55228 11 8 10.5523 8 10C8 9.44772 7.55228 9 7 9C6.44772 9 6 9.44772 6 10C6 10.5523 6.44772 11 7 11Z',
          fill: 'white',
        },
      }),
      h('path', {
        attrs: {
          d: 'M13 11C13.5523 11 14 10.5523 14 10C14 9.44772 13.5523 9 13 9C12.4477 9 12 9.44772 12 10C12 10.5523 12.4477 11 13 11Z',
          fill: 'white',
        },
      }),
      h('path', {
        attrs: {
          d: 'M16 8.03C15.7615 6.62414 15.0334 5.34797 13.9444 4.42738C12.8555 3.5068 11.4759 3.00117 10.05 3C7.01997 3 3.75997 5.51 4.01997 9.45C5.25335 8.94577 6.34268 8.14398 7.19072 7.11621C8.03876 6.08845 8.61911 4.86669 8.87997 3.56C10.19 6.19 12.88 8 16 8.03Z',
          fill: 'white',
        },
      }),
    ])
  },
}

export default {
  name: 'Paywall1',
  components: {
    DiamondIcon,
    ChatIcon,
    StarIcon,
    CrownIcon,
    HeadphoneIcon,
  },
  props: {
    campaign: {
      default: null,
    },
  },
  data() {
    return {
      campaignCounter: null,
      campaignCounterInterval: null,
      campaignCounterSeconds: 0,
      discountRate: 30,
      showOriginalPrice: true,
    }
  },
  created() {
    if (this.campaign && this.campaign.campaignId) {
      if (this.campaign.campaignType === 'ONE_TIME_OFFER') {
        this.campaignCounter = null

        if (this.campaign.remainingCounter || this.campaign.paywallCounter) {
          this.campaignCounterSeconds = (this.campaign.remainingCounter || this.campaign.paywallCounter) || 0
          this.campaignCounterSeconds *= 60 // Dakika cinsinden döndüğü için 60 ile çarpılıyor

          this.campaignCounterInterval = setInterval(() => {
            if (this.campaignCounterSeconds > 0) {
              this.campaignCounterSeconds -= 1
              const remainingHours = Math.floor(this.campaignCounterSeconds / 3600)
              const remainingMinutes = Math.floor((this.campaignCounterSeconds % 3600) / 60)
              const remainingSeconds = this.campaignCounterSeconds % 60

              this.campaignCounter = {
                hours: remainingHours < 10 ? `0${remainingHours}` : remainingHours,
                minutes: remainingMinutes < 10 ? `0${remainingMinutes}` : remainingMinutes,
                seconds: remainingSeconds < 10 ? `0${remainingSeconds}` : remainingSeconds,
              }
            } else {
              clearInterval(this.campaignCounterInterval)
              this.campaignCounterInterval = null
            }
          }, 1000)
        }
      }
    }
  },
  computed: {
    diamond() {
      try {
        const { androidProduct } = this.campaign

        if (!androidProduct) {
          return null
        }

        const match = androidProduct.match(/\.(\d+)n$/)

        if (match && match[1]) {
          return parseInt(match[1], 10)
        }

        return null
      } catch (e) {
        return null
      }
    },
    features() {
      return [
        { icon: 'diamond-icon', text: this.diamond ? this.$t('{count} Diamonds', { count: numberFormat(this.diamond) }) : null },
        { icon: 'star-icon', text: this.$t('Boho Club Member Label') },
        { icon: 'crown-icon', text: this.$t('Access to Premium Profiles') },
        { icon: 'headphone-icon', text: this.$t('24/7 Live Support') },
      ]
    },
    originalPrice() {
      // %30 indirimli fiyatın orijinal halini hesaplama
      if (!this.campaign.amount) return ''
      const amount = parseFloat(this.campaign.amount)
      // eslint-disable-next-line no-restricted-globals
      if (isNaN(amount)) return ''
      return (amount / (1 - (this.discountRate / 100))).toFixed(2)
    },
  },
  methods: {
    handleBuy() {
      if (this.campaign) {
        if (this.campaign.webProduct) {
          this.$router.push({
            name: 'buy',
            params: {
              productId: this.campaign.webProduct,
              purchaseSource: 'offer-1',
            },
            query: {
              campaignId: this.campaign.campaignId,
              campaignType: this.campaign.campaignType,
            },
          })
        } else {
          this.$router.push({
            name: 'market',
            params: { purchaseSource: 'offer-1' },
          })
        }

        this.$emit('close')
      }
    },
    handleClose() {
      this.$emit('close')
    },
    numberFormat,
  },
}
</script>

<style lang="scss" scoped>
@import url('https://fonts.googleapis.com/css2?family=Righteous&display=swap');

.p1-container {
  position: fixed;
  max-width: 500px;
  width: 100%;
  margin: -92px auto 0 auto;
  padding: 0;
  height: 100vh !important;
  z-index: 99999;
  overflow: hidden;
  left: 50%;
  transform: translateX(-50%);

  .inner-container {
    position: relative;
    height: 100% !important;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    z-index: 1;
    padding: 16px;
  }

  .overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: linear-gradient(
            to bottom,
            rgba(0, 0, 0, 0.3) 0%,
            rgba(0, 0, 0, 0.6) 40%,
            rgba(0, 0, 0, 1) 70%
    );
    z-index: 0;
  }

  .video-background {
    position: absolute;
    left: -28px;
    top: 0;
    min-width: 118%;
    min-height: 70%;
    max-height: 80%;
    width: auto;
    height: auto;
    z-index: -1;
    object-fit: cover;
    overflow: hidden;
  }

  .close-button {
    position: absolute;
    right: 18px;
    top: 4px;
    color: white;
    font-size: 26px;
    background: none;
    border: none;
    cursor: pointer;
    z-index: 2;
  }

  .header {
    font-family: "Righteous", serif;
    margin-bottom: 16px;
    margin-top: 24px;
    font-weight: 400;
  }

  .title {
    font-family: "Righteous", serif;
    font-size: 27px;
    font-weight: 400;
    margin-bottom: 12px;
    letter-spacing: 2px;
    max-width: 95%;
    color: #fff;
  }

  .subtitle {
    font-family: "Righteous", serif;
    font-size: 19px;
    color: #e0e0e0;
    line-height: 1.4;
    margin-bottom: 24px;
    font-weight: 400;
  }

  .features {
    margin-bottom: 12px;
  }

  .feature-item {
    display: flex;
    align-items: center;
    margin-bottom: 16px;
    font-size: 16px;
    gap: 14px;
    color: #e0e0e0;
  }

  .muted-text {
    color: #6d5d82;
    font-size: 11px;
    margin-bottom: 12px;
  }

  .price-container {
    border-radius: 12px;
    padding: 18px;
    margin-bottom: 24px;
    border: 2px solid #966df4;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .price {
    font-size: 20px;
    font-weight: bold;
    color: #fff !important;
  }

  .original-price {
    text-decoration: line-through;
    color: #FD6BFF;
    font-size: 13px;
  }

  .price-slogan {
    font-family: "Poppins", sans-serif;
    font-size: 12px;
    color: #c297ff;
    text-decoration: none !important;
    margin-left: 6px;
  }

  .discount-badge {
    background: linear-gradient(
            to bottom,
            #ff006f 0%,
            #ff001a 100%
    );
    font-family: "Poppins", sans-serif;
    font-weight: 700;
    padding: 5px 8px;
    border-radius: 20px;
    color: white;
    font-size: 13px;
    margin-top: -8px;
    text-align: center;
    text-transform: uppercase;
  }

  .start-button {
    font-family: "Poppins", sans-serif;
    width: 100%;
    background: #6e00c7;
    color: white;
    border: none;
    padding: 16px;
    border-radius: 50px;
    font-size: 22px;
    font-weight: 700;
    cursor: pointer;
    margin-bottom: 6px;
  }

  .text-center {
    text-align: center;
  }

  .paywall-footer {
    display: flex;
    justify-content: center;
    gap: 16px;
    font-size: 14px;
    margin-top: 32px;
    margin-bottom: 16px;
  }

  .paywall-footer span {
    color: #ffffff;
    text-decoration: none !important;
    font-size: 12px;
    cursor: pointer;
  }

  .paywall-footer span:not(:last-child) {
    border-right: 1px solid #c08de5;
    padding-right: 16px;
  }
}
</style>
